// extracted by mini-css-extract-plugin
export var content = "YourInvitesModal-module__content___Am0YU";
export var container = "YourInvitesModal-module__container___MxPJk";
export var heart = "YourInvitesModal-module__heart___HOINT";